export const DASHBOARD_URL = 'https://app.prophecius.in';
export const LADNING_URL = 'https://director.prophecius.in';
// export const baseURL = "http://localhost:8000";
export const baseURL = "https://directorapi.prophecius.in";
export const apiBaseURL = `${baseURL}/api`;